import React, { Component } from 'react';
import '../styles/Empresa.css';
import empresaBanner from '../images/empresa-banner.png'
import Banner from './Banner'
import ShowMore from './ShowMore'
import radiografiaIcon from '../images/empresa/radiografia.svg'
import carritoIcon from '../images/empresa/carrito.svg'
import entidadIcon from '../images/empresa/entidad-publica.svg'
import farmaciaIcon from '../images/empresa/farmacia.svg'
import ScrollTop from './ScrollTop'
import Analytics from './Analytics'

class Empresa extends Component {
    
    render(){
        return (
            <div className="Empresa">
                <ScrollTop />
                <Analytics />
                <div class="empresa-container">
                    <Banner className="banner-empresa-container" title="Nuestra empresa"
                     description="Somos Flexibles por que nacimos flexibles" 
                     textButton="MODELO DE NEGOCIO" imageBanner={empresaBanner} />
                    <div class="empresa-servicios">
                        <h1>BRINDAMOS SERVICIOS DE EXCELENCIA</h1>
                        <p>Nacida de la idea y necesidades de seis <span class="bold-text">Laboratorios internacionales y nacionales</span> de primera línea, 
                        <span class="bold-text"> en</span> <span class="orange-text">1999</span> <span class="bold-text">se constituye</span> <span class="orange-text">GLOBALFARM</span> como alternativa que suplante y mejore los servicios antes utilizados por cada una de las empresas participantes.
                             Somos el departamento comercial y logístico de cada una de estas prestigiosas empresas.
                             <span class="italic-text">  Nacimos Flexibles para adaptarnos permanentemente a las necesidades de su empresa y el mercado.</span> </p>
                        <div class="empresa-servicio-grid">
                            <div class="item-service-grid">
                                <h3 class="head-service-grid"><span class="head-service-big">98</span>%</h3>
                                <span class="text-service-grid">Eficiencia de entregas</span>
                            </div>
                            <div class="item-service-grid">
                                <h3 class="head-service-grid"><span class="head-service-big">0,03</span>%</h3>
                                <span class="text-service-grid">Faltantes y roturas menores</span>
                            </div>
                            <div class="item-service-grid">
                                <h3 class="head-service-grid"><span class="head-service-big">99,5</span>%</h3>
                                <span class="text-service-grid">Disponibilidad de sistemas</span>
                            </div>
                            <div class="item-service-grid">
                                <h3 class="head-service-grid">PROCESAMIENTO SEMANAL</h3>
                                <span class="text-service-grid">de devoluciones</span>
                            </div>
                            <div class="item-service-grid">
                                <h3 class="head-service-grid"><span class="head-service-big">100.000</span> kg.</h3>
                                <span class="text-service-grid">Material promocional mensual</span>
                            </div>
                            <div class="item-service-grid">
                                <h3 class="head-service-grid"><span class="head-service-big">1.300</span> APMS</h3>
                                <span class="text-service-grid">Entrega de material</span>
                            </div>
                        </div>
                    </div>
                    <div class="empresa-clientes">
                        <h1>CLIENTES OPERATIVOS</h1>
                        <div class="empresa-clientes-grid">
                            <div class="clientes-grid-item">
                                <img src={farmaciaIcon} />
                                <p>Farmacias 
                                    - Droguerías</p>
                            </div>
                            <div class="clientes-grid-item">
                                <img src={entidadIcon} />
                                <p>Instituciones 
                                    Públicas - Privadas</p>
                            </div>
                            <div class="clientes-grid-item">
                                <img src={radiografiaIcon} />
                                <p>Servicios e institutos de Radiología</p>
                            </div>
                            <div class="clientes-grid-item">
                                <img src={carritoIcon} />
                                <p>Droguerias especiales de convenios</p>
                            </div>
                        </div>
                    </div>
                    <div class="mision-container">
                        <h2>Misión</h2>
                        <p><span>Nuestra distribuidora</span> es una empresa concebida y creada para asegurar el libre acceso de todos los argentinos
                             a los productos farmacéuticos de las compañías que la integran. <span class="read-more-target" id="text-mision"> Por lo tanto, queda definida su razón de ser 
                             como <span>alternativa que suplante y mejore los servicios antes utilizados por cada una de las empresas participantes.</span></span></p>
                        <div class="show-more">
                            <ShowMore textId="text-mision"/>
                        </div>
                    </div>
                    <hr class="line-separator" />
                    <div class="mision-container mision-reverse-grid">
                        <p>Ser la <span>mejor alternativa del mercado</span> para la distribución de medicamentos.</p>
                        <h2>Visión</h2>
                    </div>
                    <hr class="line-separator" />
                    <div class="mision-container">
                        <h2>Valores</h2>
                        <p>Nuestros valores son la <span>excelencia de nuestro trabajo</span> brindado por el grupo humano que nos integra, la tecnología aplicada al negocio y la flexibilidad para adaptarnos a los cambios del mercado brindando una visión estratégica a los laboratorios y clientes que atendemos. Trabajamos con los más altos estándares de calidad, integridad y transparencia, alineados con los principios de compliance que tienen las compañías que nos integran.</p>

                    </div>
                    <hr class="line-separator" />
                    <div class="politica">
                        <h2>Nuestra política de calidad</h2>
                        <p>Globalfarm, <span>es una empresa dedicada a prestar Servicios de Distribución y Comercialización de los productos de sus Comitentes y Clientes. </span>
                            Entendemos por Calidad alcanzar la satisfacción total a través del cumplimiento en tiempo y forma de todas las operaciones en las condiciones acordadas.
                             <span class="read-more-target" id="text-politica"> Para ello adoptamos y mantenemos los siguientes principios: Realizar una <span>gestión responsable frente a la sociedad, cumplir con las leyes y reglamentaciones 
                              aplicables</span>, permitiendo el libre acceso a los productos comercializados.  Crear valor agregado en los procesos y actividades mediante el aprendizaje, las técnicas de prevención, el trabajo en equipo y la mejora continua.  Mantener una interacción con los Comitentes y Clientes, basada en la transparencia y confidencialidad, generando una relación mutuamente beneficiosa para superar sus expectativas. 
                               Establecer un grado de colaboración y compromiso con nuestros proveedores en el ámbito de la calidad.
                               Concientizar a todo el personal en el cuidado y preservación del medio ambiente, como así también trabajar en un ambiente seguro y sin accidentes.
                                Capacitar, adiestrar e integrar a todo el personal en todos los niveles y en todos los procesos en el Sistema de Gestión de la Calidad y los Objetivos de la Compañía.
                                 Para cumplir y mantener lo manifestado es que <span>nuestra gestión está basada y forjada en un Sistema de Gestión de la Calidad y Mejora continua.</span></span></p>
                        <div class="show-more">
                            <ShowMore textId="text-politica"/>
                        </div>
                    </div>

                    <div class="certificaciones-container">
                        <h1>CERTIFICACIONES <br/>NACIONALES E INTERNACIONALES</h1>
                        <div class="certificaciones-grid">
                            <ul>
                                <li>Habilitación ANMAT</li>
                                <li>Medicamentos</li>
                                <li>Alimentos</li>
                            </ul>
                            <ul>
                                <li>Reactivos para diagnóstico</li>
                                <li>Ensayos clínicos</li>
                                <li>Certificación ISO 9001</li>
                            </ul>
                            <ul>
                                <li>Certificación ISAE 3402</li>
                                <li>Sistema Validado según Normas GAMP 5.</li>
                                <li>Sarbanes-Oxley (Procesos Operativos)</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Empresa;


// WEBPACK FOOTER //
// ./src/components/Empresa.js